/* =====================================================================
   Lactamo Store Locator - mobiel gedrag
   Auteur: Frederiek Pascal - ClickForest (https://www.clickforest.com)
   Doel:   Op mobiel start de winkellijst standaard INGEKLAPT, zodat de
           kaart meteen zichtbaar is (anders legt het lijstpaneel zich
           over de hele kaart). We gebruiken de eigen toggle-knop van de
           TA MAPPY-app ('Store list'), dus de knop blijft gewoon werken
           om de lijst weer open te klappen.
   Scope:  enkel de store-locator-widget; doet niets op desktop.
   ===================================================================== */
(function () {
  'use strict';
  var MOBILE_MAX = 767; // px: onder deze breedte = mobiel
  var done = false;
  var tries = 0;
  var MAX_TRIES = 40; // ~10s aan pogingen (widget laadt asynchroon)

  function lijstStaatOpen() {
    var lijst = document.querySelector('#store-locator-page .bss-store-result');
    if (!lijst) return false;
    var r = lijst.getBoundingClientRect();
    return r.width > 10 && r.height > 10;
  }

  function probeerInklappen() {
    if (done) return true;
    tries++;
    // Enkel op mobiel; op desktop niets doen.
    if (window.innerWidth > MOBILE_MAX) { done = true; return true; }
    var knop = document.querySelector('#store-locator-page .store-list-button');
    if (knop && lijstStaatOpen()) {
      knop.click(); // gebruikt de eigen toggle-logica van de app
      done = true;
      return true;
    }
    return tries >= MAX_TRIES; // geef op na MAX_TRIES
  }

  function start() {
    if (probeerInklappen()) return;
    var iv = setInterval(function () {
      if (probeerInklappen()) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
